import Stack, { type StackProps } from '@mui/material/Stack'

export const HStack = (props: StackProps) => {
  return <Stack direction="row" {...props} />
}

export type { StackProps as HStackProps }
